import { useMemo } from "react";

import BaseLayout from "@/base";
import ChallengesLayout from "@/challenges/ChallengesLayout";
import useIsAuthorizedForIndependentReadingChallenge from "@/challenges/utils/useIsAuthorizedForIndependentReadingChallenge/useIsAuthorizedForIndependentReadingChallenge";
import getUserProperties from "@/users/getUserProperties";
import useUser from "@/users/useUser";
import UnauthenticatedUserError from "@/view/ViewPageError/UnauthenticatedUserError";

const withChallengesPrivileges = (WrappedComponent) => {
  const WrappedWithApprovedUsers = () => {
    const { data: user, loading: userLoading } = useUser();
    const userProperties = useMemo(() => getUserProperties(user), [user]);
    const { isAuthenticatedUser, isStaff } = userProperties;
    const isAuthorizedChallengesPageUser =
      useIsAuthorizedForIndependentReadingChallenge() || isStaff;
    if (userLoading) {
      return <BaseLayout mainContents="loading" />;
    }

    if (!isAuthenticatedUser) {
      return <BaseLayout mainContents={<UnauthenticatedUserError />} />;
    }

    if (!isAuthorizedChallengesPageUser) {
      return <BaseLayout mainContents={<ChallengesLayout />} />;
    }

    return <WrappedComponent />;
  };
  return WrappedWithApprovedUsers;
};

export default withChallengesPrivileges;
